const config = {
  env: process.env.NODE_ENV,
  publicUrl: process.env.PUBLIC_URL,
  apiUrl: process.env.REACT_APP_API_URL,
  snapPopPath: '/peeppop/1.0',
  audience: process.env.REACT_APP_AUDIENCE,
  clientId: process.env.REACT_APP_WEB_CLIENT_ID,
  clientSecret: process.env.REACT_APP_WEB_CLIENT_SECRET,
  logActionView: process.env.REACT_APP_LOG_ACTION_VIEW_ID,
  popId: process.env.REACT_APP_POP_ID,
};

export default config;
